module.exports = __webpack_public_path__ + "static/img/logo.a56f72f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tenant/msb/logo.png
// module id = Mrwn
// module chunks = 1